// يفتح تقرير «الرواتب الموقوفة» في نافذة طباعة بنفس أسلوب تقارير الرواتب.
import { css } from "./reportTokens";
import { esc, today } from "./reportFormat";
import { HL } from "./holdsReportLabels";
import { holdsCards, holdsHeader, holdsRules, holdsTable } from "./holdsReportParts";
import { signature } from "./reportPages";
import { shareBar } from "../reports/shareBar";
import { pdfScript } from "../reports/pdfActions";
import { refLine } from "../reports/refLine";
import { openSharedReportWindow } from "../reports/openShared";
import { printButton } from "../reports/reportButtons";

const buttons = (L, share, pdfUrl) => `<div class="pdf-bar">
  ${printButton(L)}
  ${pdfUrl ? `<button class="btn-pdfshare" data-testid="report-share-pdf" onclick="shareReportPdf()">${esc(L.sharePdf)}</button>` : ""}
  ${share?.url ? `<button class="btn-copy" data-testid="holds-report-copy-top"
    onclick="copyReportLink('${esc(share.short || share.url)}')">${esc(L.copyLink)}</button>` : ""}
  <button class="btn-close" data-testid="report-close" onclick="reportClose()">${esc(L.close)}</button>
</div>`;

export const buildHoldsReportHtml = (data, lang = "ar", brand = null, share = null, pdfUrl = null) => {
  const L = HL[lang === "en" ? "en" : "ar"];
  const rtl = lang !== "en";
  return `<!DOCTYPE html>
<html lang="${rtl ? "ar" : "en"}" dir="${rtl ? "rtl" : "ltr"}">
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>${esc(share?.title || L.title)}</title><style>${css(false)}</style></head>
<body>
${buttons(L, share, pdfUrl)}
${refLine(share, L.reference)}
${holdsHeader(data, L, brand)}
${holdsCards(data, L)}
${holdsTable(data, L)}
${holdsRules(data, L)}
${signature(L)}
<div class="footer">${esc(L.footer)} | ${today()}</div>
${shareBar(share?.url, L.copied)}
${pdfScript(pdfUrl, share?.title || L.title, L)}
</body></html>`;
};

export const openHoldsReport = (data, lang, brand, win = null, ticketPromise = null) => {
  const opts = { pdfUrl: null };
  return openSharedReportWindow({
    title: `${HL[lang === "en" ? "en" : "ar"].title} · ${today()}`,
    win,
    ticket: null,
    pdfUrl: null,
    ticketPromise,
    opts,
    fileName: `salary-holds-${today()}`,
    lang,
    meta: {
      company: brand?.name,
      branch: (data.branch_rules || []).map((r) => r.branch_name).filter(Boolean).join(" · "),
      period: today(),
    },
    build: (share) => buildHoldsReportHtml(data, lang, brand, share, opts.pdfUrl),
  });
};
